module.exports = __webpack_public_path__ + "static/media/services-icon-2.1d52aa9e.svg";